import classNames from 'classnames'
import { Override } from 'maeng-type/Common'
import { ComponentProps, ReactNode, forwardRef, useMemo } from 'react'

export type BadgeProps = Override<
  ComponentProps<'span'>,
  {
    children?: ReactNode
    color?:
      | 'neutral'
      | 'primary'
      | 'secondary'
      | 'accent'
      | 'ghost'
      | 'info'
      | 'success'
      | 'warning'
      | 'error'
    outlined?: boolean
    size?: 'xs' | 'sm' | 'md' | 'lg'
  }
>

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  (
    { children, color = 'neutral', outlined, size = 'md', className: classProps = '', ...props },
    ref,
  ) => {
    const className = useMemo(() => {
      const colors = {
        'badge-neutral': color === 'neutral',
        'badge-primary': color === 'primary',
        'badge-secondary': color === 'secondary',
        'badge-accent': color === 'accent',
        'badge-ghost': color === 'ghost',
        'badge-info': color === 'info',
        'badge-success': color === 'success',
        'badge-warning': color === 'warning',
        'badge-error': color === 'error',
      }

      const sizes = {
        'badge-xs': size === 'xs',
        'badge-sm': size === 'sm',
        'badge-md': size === 'md',
        'badge-lg': size === 'lg',
      }
      return classNames({
        badge: true,
        'badge-outline': !!outlined,
        ...colors,
        ...sizes,
        [classProps]: true,
      })
    }, [classProps, color, outlined, size])

    return (
      <span ref={ref} className={className} {...props}>
        {children}
      </span>
    )
  },
)

export default Badge
